<router-outlet></router-outlet>
<div id="consent-manager"></div>
<loader></loader>
<ngx-spinner size="medium" class="app-spinner" type="ball-scale-multiple"></ngx-spinner>

